import { ProcessorType } from '@weave/schema-gen-ts/dist/schemas/payments/messages/values/values.pb';
import { PaymentOrigin } from '@frontend/api-invoices';
import { TFunction } from '@frontend/i18n';
import { paymentTypeMap } from '@frontend/payments-hooks';
import { PaymentRow } from '../../types/invoice';

type Props = {
  payment: PaymentRow;
  emptyLabel?: string;
  t: TFunction;
};

export const getPaymentOriginLabel = ({ emptyLabel = '-', payment: { origin, processorType }, t }: Props) => {
  if (processorType === ProcessorType.CARE_CREDIT_PROCESSOR) {
    if (origin === PaymentOrigin.ManualCardEntry) {
      return t('CareCredit', { ns: 'payments' });
    }

    if (origin === PaymentOrigin.TextToPay) {
      return t('CareCredit URL', { ns: 'payments' });
    }
  }

  return origin ? paymentTypeMap[origin] : emptyLabel;
};
